exports.connect = {
	url: "https://api.lecloslalande.camp/"
}
